// resources/js/Pages/HallOfFame/components/radarPercentiles.js
//
// Which radar axes the vault row may plot. The server (ScriptVaultController::sceneRadarPercentiles)
// is the ONLY authority: it applies the same-reader gate and returns null when the comparison is
// unavailable or only approximate. Null / missing / blank axes are "not compared" — never
// recomputed here from raw scores, which would mix readers (R30 review, 2026-10-09).
//
// Pure (no React, no DOM) so test/test_radar_percentile_contract.mjs can run it under node.

export const RADAR_MIN_AXES = 3;

export function radarPoints(serverPct, metrics, scores = {}) {
    const points = [];
    const missing = [];
    if (!serverPct || typeof serverPct !== 'object') {
        return { available: false, points, missing: Object.keys(metrics) };
    }
    for (const [label, { field }] of Object.entries(metrics)) {
        const sp = serverPct[label];
        const n = (sp === undefined || sp === null || sp === '') ? NaN : Number(sp);
        if (!Number.isFinite(n)) {
            missing.push(label);
            continue;
        }
        points.push({ label, field, percentile: Math.round(n), rawScore: scores?.[field] });
    }
    return { available: points.length >= RADAR_MIN_AXES, points, missing };
}
